import type { SVGProps } from "react";

export type NotesIconProps = SVGProps<SVGSVGElement>;

/**
 * Small pencil-on-paper icon used for row-level notes actions (e.g. CMM orders table).
 *
 * @param props - Standard SVG attributes (e.g. `className`, `aria-hidden`).
 * @returns Inline SVG element.
 */
const NotesIcon = (props: NotesIconProps) => {
  const { className, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      aria-hidden
      {...rest}
    >
      <path
        d="M14.0003 14.0015H8.66701M1.66699 14.3348L5.36651 12.9119C5.60313 12.8209 5.72145 12.7754 5.83214 12.716C5.93046 12.6632 6.02419 12.6023 6.11235 12.5339C6.21161 12.4569 6.30124 12.3673 6.48051 12.188L14.0003 4.66817C14.7367 3.93179 14.7367 2.73788 14.0003 2.0015C13.264 1.26512 12.0701 1.26512 11.3337 2.0015L3.81385 9.52132C3.63458 9.70059 3.54494 9.79022 3.46792 9.88948C3.39951 9.97764 3.33859 10.0714 3.28582 10.1697C3.2264 10.2804 3.18089 10.3987 3.08988 10.6353L1.66699 14.3348ZM1.66699 14.3348L3.03907 10.7675C3.13726 10.5122 3.18635 10.3846 3.27055 10.3261C3.34414 10.275 3.43519 10.2557 3.52319 10.2725C3.62388 10.2917 3.72058 10.3884 3.91398 10.5818L5.42004 12.0879C5.61344 12.2813 5.71014 12.378 5.72937 12.4787C5.74617 12.5667 5.72685 12.6577 5.67576 12.7313C5.61729 12.8155 5.48965 12.8646 5.23437 12.9628L1.66699 14.3348Z"
        stroke="#0056D6"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotesIcon;
